import { createFileRoute } from "@tanstack/react-router";
import { JoinLeagueForm } from "@/features/leagues/components/JoinLeagueForm";
import { useT } from "@/shared/i18n";
import { PageContainer } from "@/shared/layout/PageContainer";
import { PageHeader } from "@/shared/layout/PageHeader";

export const Route = createFileRoute("/_authenticated/leagues/join")({
  component: JoinLeaguePage,
});

function JoinLeaguePage() {
  const t = useT();
  return (
    <PageContainer width="narrow">
      <PageHeader
        eyebrow={t("nav.league")}
        title={t("join.title")}
        subtitle={t("join.subtitle")}
      />
      <JoinLeagueForm />
    </PageContainer>
  );
}
